import { useMutation } from '@tanstack/react-query';

import { checkSignatureStatus } from '@services/document-signer/document-signer.service';

export function useCheckSignatureStatus(accessToken: string) {
  return useMutation({
    mutationFn: (orderId: string) => checkSignatureStatus(orderId, accessToken),
  });
}
